import { Button } from "@sunfish/ui";

type Attendee = {
	attendeeId: string;
	firstName: string | null;
	lastName: string | null;
	email: string | null;
	status: "in" | "out" | "none";
	lastEventAt: string | null;
	lastClientId: string | null;
};

export function AttendeeCard({
	attendee,
	showEmail,
	checkoutEnabled,
	onCheckIn,
	onCheckOut,
	onUndo,
}: {
	attendee: Attendee;
	showEmail: boolean;
	checkoutEnabled: boolean;
	onCheckIn: () => void;
	onCheckOut: () => void;
	onUndo: () => void;
}) {
	const name = `${attendee.firstName ?? ""} ${attendee.lastName ?? ""}`.trim() || "Unknown";
	const alreadyIn = attendee.status === "in";

	return (
		<div className="rounded-xl bg-slate-900 text-slate-100 p-5 w-full max-w-md">
			{alreadyIn && (
				<div className="mb-3 rounded bg-amber-500/15 text-amber-300 text-sm px-3 py-2">
					⚠ Already checked in
					{attendee.lastEventAt ? ` at ${new Date(attendee.lastEventAt).toLocaleTimeString()}` : ""}
				</div>
			)}
			<div className="text-2xl font-semibold">{name}</div>
			{showEmail && attendee.email && <div className="text-sm text-slate-400">{attendee.email}</div>}
			<div className="mt-4 flex gap-2">
				{!alreadyIn && (
					<Button className="flex-1 bg-green-600 hover:bg-green-700" onClick={onCheckIn}>
						✓ Check In
					</Button>
				)}
				{alreadyIn && attendee.lastClientId && (
					<Button variant="outline" className="flex-1" onClick={onUndo}>
						Undo
					</Button>
				)}
				{alreadyIn && checkoutEnabled && (
					<Button className="flex-1" onClick={onCheckOut}>
						Check out →
					</Button>
				)}
			</div>
		</div>
	);
}
